import { Navigate } from "react-router-dom";
import { hasUsableSession } from "../helpers/authSession";

const ProtectedRoute = ({ children }: any) => {
  if (hasUsableSession()) {
    return children;
  } else {
    return <Navigate to="/" />;
  }
};

export default ProtectedRoute;
